export default "__VITE_ASSET__6b45b9b6__"